
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/new",
      function () {
        return require("private-next-pages/search/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/new"])
      });
    }
  